import api from "./api"

// eslint-disable-next-line
export const logout = async () => {
	await api.get("/auth/logout").finally(() => {
		window.location = `${process.env.REACT_APP_GALLERY_PRO_URL}/login`
	})
}
